module.exports = __webpack_public_path__ + "static/IBMPlexSans-Bold-9505572e17d333f0ffe7131f95a5992d.woff";